module.exports = __webpack_public_path__ + "img/obit_bg.e722cf61.jpg";